import { orderBy } from 'lodash';

import type { Subcampaign } from 'types';

import {
  SUBCAMPAIGN_STATE_ACCEPTED,
  SUBCAMPAIGN_STATE_DRAFT,
  SUBCAMPAIGN_STATE_PENDING,
  SUBCAMPAIGN_STATE_REVOKED
} from './subcampaign';

export const PARTICIPANT_TYPE_SHORTLISTED = 'shortlisted';
export const PARTICIPANT_TYPE_PENDING = 'pending';
export const PARTICIPANT_TYPE_AGREED = 'agreed';
export const PARTICIPANT_TYPE_REVOKED = 'revoked';

export const PARTICIPANT_TYPES_ORDER = [
  PARTICIPANT_TYPE_SHORTLISTED,
  PARTICIPANT_TYPE_PENDING,
  PARTICIPANT_TYPE_AGREED,
  PARTICIPANT_TYPE_REVOKED
];

export const PARTICIPANT_TYPE_TO_STATE_MAP = {
  [PARTICIPANT_TYPE_SHORTLISTED]: { state: SUBCAMPAIGN_STATE_DRAFT, overviewName: 'draftOverview' },
  [PARTICIPANT_TYPE_PENDING]: { state: SUBCAMPAIGN_STATE_PENDING, overviewName: 'pendingOverview' },
  [PARTICIPANT_TYPE_AGREED]: { state: SUBCAMPAIGN_STATE_ACCEPTED, overviewName: 'acceptedOverview' },
  [PARTICIPANT_TYPE_REVOKED]: { state: SUBCAMPAIGN_STATE_REVOKED, overviewName: 'revokedOverview' }
};

export const SUBCAMPAIGN_STATE_TO_PARTICIPANT_TYPE_MAP = {
  [SUBCAMPAIGN_STATE_DRAFT]: PARTICIPANT_TYPE_SHORTLISTED,
  [SUBCAMPAIGN_STATE_PENDING]: PARTICIPANT_TYPE_PENDING,
  [SUBCAMPAIGN_STATE_ACCEPTED]: PARTICIPANT_TYPE_AGREED,
  [SUBCAMPAIGN_STATE_REVOKED]: PARTICIPANT_TYPE_REVOKED
};

export function isParticipantTypeSupported(type: string): boolean {
  return Boolean(type) && PARTICIPANT_TYPES_ORDER.includes(type);
}

export function sortParticipants(subcampaigns: Array<Subcampaign>): Array<Subcampaign> {
  // $FlowIgnore
  return orderBy(subcampaigns, ['creatorProfile.channels.instagram.metrics.followers'], ['desc']);
}
